import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  { q: 'What is the expected timeline for trademark registration?', a: 'The complete process typically spans 8 to 12 months from filing to certificate issuance. Our team files your application within 24 to 48 hours. The majority of time is attributable to the USPTO examination queue, which we actively monitor.' },
  { q: 'What does the $45 filing package include?', a: 'The Essentials package includes a preliminary search, filing preparation, document review, and electronic submission to the USPTO. For comprehensive attorney-drafted applications, we recommend the Standard or Professional packages.' },
  { q: 'Can a mark be registered if a similar one exists?', a: 'Registrability depends on similarity and relatedness of goods and services. Our clearance search examines existing registrations, pending applications, and common law usage. If a conflict is identified, we provide alternatives.' },
  { q: 'Is formal registration necessary if I am already using the name?', a: 'Common law rights are geographically limited. Federal registration provides nationwide exclusive rights, legal presumption of validity, statutory damages eligibility, and the ability to record with U.S. Customs.' },
  { q: 'What recourse is available if an application is refused?', a: 'We maintain a 98% approval rate. If the USPTO issues an office action, our attorneys prepare comprehensive responses. Standard packages and above include these at no additional cost.' }
];

const LPFAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  return (
    <section className="py-24 bg-[#F9F8F6]" data-testid="lp-faq-section">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="eyebrow mb-4">FAQ</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter">Common questions</h2>
        </div>
        <div className="space-y-0">
          {faqs.map((faq, i) => (
            <div key={i} className="border-b border-[#D5D1C8]" data-testid={`lp-faq-item-${i}`}>
              <button onClick={() => setOpenFAQ(openFAQ === i ? null : i)} className="w-full py-6 text-left flex items-center justify-between group" data-testid={`lp-faq-toggle-${i}`}>
                <h3 className="font-display text-base font-medium text-[#111C16] pr-8 group-hover:text-[#C85A40] transition-colors">{faq.q}</h3>
                <ChevronDown className={`h-5 w-5 text-[#4A5D53] flex-shrink-0 transition-transform duration-300 ${openFAQ === i ? 'rotate-180 text-[#C85A40]' : ''}`} strokeWidth={1.5} />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openFAQ === i ? 'max-h-96 pb-6' : 'max-h-0'}`}>
                <p className="font-body text-sm text-[#4A5D53] leading-relaxed pr-12">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LPFAQSection;
